import _slicedToArray from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["event"];
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { addTelemetryDebug, createHttpRequest, jsonStringify, objectEntries } from '@datadog/browser-core';
export function createFormDataTransport(configuration, lifeCycle, createEncoder, streamId) {
  var reportError = function reportError(error) {
    lifeCycle.notify(14 /* LifeCycleEventType.RAW_ERROR_COLLECTED */, {
      error: error
    });
    // monitor-until: forever, to keep an eye on the errors reported to customers
    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };
  var httpRequest = createHttpRequest([configuration.profilingEndpointBuilder], reportError);
  var encoder = createEncoder(streamId);
  return {
    send: function send(_ref) {
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var event, attachments, formData, serializedEvent, bytesCount, _iterator, _step, _step$value, key, value, serializedValue, result, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event = _ref.event, attachments = _objectWithoutProperties(_ref, _excluded);
              formData = new FormData();
              serializedEvent = jsonStringify(event);
              if (serializedEvent) {
                _context.next = 1;
                break;
              }
              throw new Error('Failed to serialize event');
            case 1:
              formData.append('event', new Blob([serializedEvent], {
                type: 'application/json'
              }), 'event.json');
              bytesCount = serializedEvent.length;
              _iterator = _createForOfIteratorHelper(objectEntries(attachments));
              _context.prev = 2;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 7;
                break;
              }
              _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value = _step$value[1];
              serializedValue = jsonStringify(value);
              if (serializedValue) {
                _context.next = 4;
                break;
              }
              throw new Error('Failed to serialize attachment');
            case 4:
              _context.next = 5;
              return encode(encoder, serializedValue);
            case 5:
              result = _context.sent;
              bytesCount += result.outputBytesCount;
              formData.append(key, new Blob([result.output]), key);
            case 6:
              _context.next = 3;
              break;
            case 7:
              _context.next = 9;
              break;
            case 8:
              _context.prev = 8;
              _t = _context["catch"](2);
              _iterator.e(_t);
            case 9:
              _context.prev = 9;
              _iterator.f();
              return _context.finish(9);
            case 10:
              httpRequest.send({
                data: formData,
                bytesCount: bytesCount
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 8, 9, 10]]);
      }))();
    }
  };
}
function encode(encoder, data) {
  return new Promise(function (resolve) {
    encoder.write(data);
    encoder.finish(function (encoderResult) {
      resolve(encoderResult);
    });
  });
}